import { createContext, useContext, useState } from "react";

const EnquiryContext = createContext(null);

export function EnquiryProvider({ children }) {
    const [selected, setSelected] = useState([]);

    const has = (slug) => selected.some((x) => x.slug === slug);
    const add = (slug, strength = null) =>
        setSelected((s) => (s.some((x) => x.slug === slug) ? s : [...s, { slug, strength, vials: 10 }]));
    const addCustom = (name) => {
        const slug = `custom-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`;
        if (!slug || slug === "custom-") return;
        setSelected((s) => (s.some((x) => x.slug === slug) ? s : [...s, { slug, strength: null, vials: 10, customName: name }]));
    };
    const remove = (slug) => setSelected((s) => s.filter((x) => x.slug !== slug));
    const setStrength = (slug, strength) =>
        setSelected((s) => s.map((x) => (x.slug === slug ? { ...x, strength } : x)));
    const setVials = (slug, vials) =>
        setSelected((s) => s.map((x) => (x.slug === slug ? { ...x, vials } : x)));
    const clear = () => setSelected([]);

    return (
        <EnquiryContext.Provider value={{ selected, has, add, addCustom, remove, setStrength, setVials, clear }}>
            {children}
        </EnquiryContext.Provider>
    );
}

export function useEnquiry() {
    return useContext(EnquiryContext);
}
